<template>
  <div style="font-family: sans-serif; width: 210mm; line-height: 200%;">
    <div style="text-align: center; text-transform: uppercase;">
      Potwierdzenie odbioru usteckiej karty mieszkańca <br />
      w formie fizycznej
    </div>

    <br />

    <div>Imię i nazwisko:&nbsp;{{ fullName }}</div>

    <br />

    <div>
      <div style="vertical-align: top; display: inline-block;">
        Adres:&nbsp;
      </div>

      <div style="vertical-align: top; display: inline-block;" v-html="address" />
    </div>

    <br />

    <div>Potwierdzam odbiór Usteckiej Karty Mieszkańca w formie fizycznej o numerze&nbsp;{{ cardNumber }}.</div>

    <br />

    <div style="margin-top: 4cm; margin-left: 60%; width: 40%;">
      <div style="border-bottom: 3px dotted black;" />

      <div>(Data i podpis osoby odbierającej Kartę w wersji fizycznej)</div>
    </div>
  </div>
</template>

<script>
import { address } from '@witkac/kartamiejska-shared';

// @vuese
// Potwierdzenie odbioru karty
// @group printable
export default {
  props: {
    // Profil mieszkańca
    profile: { type: Object, required: false },
    // Karta mieszańca
    card: { type: Object, required: false }
  },
  computed: {
    fullName() {
      return this.profile ? this.profile.firstName + ' ' + this.profile.lastName : '';
    },
    cardNumber() {
      return this.card ? this.card.number : '';
    },
    address() {
      return this.profile
        ? this.addressFormat(this.profile)
            .split(', ')
            .join(',<br /> ')
        : '';
    }
  },
  methods: {
    addressFormat: address
  }
};
</script>

<style scoped>
.page {
  width: 210mm;
}
.page .address {
  vertical-align: top;
  display: inline-block;
}
.page .signature {
  margin-left: 60%;
  width: 40%;
}
.page .dotted {
  border-bottom: 3px dotted black;
}
.page .title {
  text-align: center;
  text-transform: uppercase;
}
</style>
